import React, { useMemo, useState } from 'react'

import { useStaticChangelog } from '../../hooks/useStaticChangelog.ts'
import { shouldHighlightChangelog } from '../../utils/changelog/handlers.ts'
import { ChangelogModal } from './ChangelogModal.tsx'


export function ChangelogView() {
  const [open, setOpen] = useState(false)
  const { entries, newestPublishedAtMs } = useStaticChangelog()

  const showBadge = useMemo(
    () => shouldHighlightChangelog(newestPublishedAtMs),
    [newestPublishedAtMs]
  )

  return (
    <>
       <button
        type="button"
        onClick={() => setOpen(true)}
        className="relative flex w-full items-center justify-between gap-3 rounded px-4 py-2 text-left"
        aria-label="Co nowego"
      >
        <span>Co nowego</span>

        {showBadge && (
          <span className="rounded-full bg-red-600 px-2 py-0.5 text-center text-xs text-white">
            NOWE
          </span>
        )}
      </button>

      <ChangelogModal
        open={open}
        onClose={() => setOpen(false)}
        entries={entries}
        newestPublishedAtMs={newestPublishedAtMs}
      />
    </>
  )
}
